import { responseErrorInterceptor, responseSuccessInterceptor } from '@/core/services/error.interceptor';
import axios from 'axios';
//#region Configs
export const baseConfig = {
   baseURL: import.meta.env.VITE_APP_CANDIDATE_API_URL,
};
//#endregion

//#region Axios instances
export const http = axios.create(baseConfig);
//#endregion

//#region Intercepters
http.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);
//#endregion

